import { useState, useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";

type AppTile = {
  id: string;
  label: string;
  icon: string;
  group: string;
  adminOnly?: boolean;
};

const APP_TILES: AppTile[] = [
  // Work
  { id: "projects", label: "Projects", icon: "M2 3h20v14a2 2 0 01-2 2H4a2 2 0 01-2-2V3z M8 21h8 M12 17v4", group: "Work" },
  { id: "browser", label: "Browser", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M2 12h20 M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10A15.3 15.3 0 0112 2z", group: "Work" },
  { id: "canvas", label: "Canvas", icon: "M3 3h18v18H3z M3 9h18 M9 21V9", group: "Work" },
  { id: "taskboard", label: "Task Board", icon: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z", group: "Work" },
  { id: "recipes", label: "Recipes", icon: "M4 19.5A2.5 2.5 0 016.5 17H20 M4 19.5V5a2 2 0 012-2h14v14H6.5A2.5 2.5 0 004 19.5z", group: "Work" },

  // Security & Governance
  { id: "access", label: "Access Control", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4", group: "Security" },
  { id: "quarantine", label: "Quarantine", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", group: "Security" },
  { id: "cost", label: "Cost Ledger", icon: "M12 1v22 M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6", group: "Security" },

  // Analytics
  { id: "archmap", label: "Arch Map", icon: "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z", group: "Analytics" },
  { id: "benchmark", label: "Benchmark", icon: "M12 20V10 M18 20V4 M6 20v-4", group: "Analytics" },
  { id: "drift", label: "Drift", icon: "M22 12h-4l-3 9L9 3l-3 9H2", group: "Analytics" },
  { id: "provenance", label: "Provenance", icon: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22", group: "Analytics" },
  { id: "replay", label: "Replay", icon: "M3 12a9 9 0 109-9 M3 3v9h9", group: "Analytics" },

  // System
  { id: "registry", label: "Registry", icon: "M21 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v3 M3 16v3a2 2 0 002 2h14a2 2 0 002-2v-3 M12 12m-3 0a3 3 0 106 0 3 3 0 00-6 0 M1 12h4 M19 12h4", group: "System" },
  { id: "memory", label: "Memory", icon: "M4 4h16v16H4z M4 12h16 M12 4v16 M8 4v8 M16 4v8", group: "System" },
  { id: "knowledge", label: "Knowledge", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M12 8v8 M8 12h8", group: "System" },
  { id: "tools", label: "Tools", icon: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z", group: "System" },
  { id: "settings", label: "Settings", icon: "M12 15a3 3 0 100-6 3 3 0 000 6z M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z", group: "System" },
  { id: "admin", label: "Admin", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M8.5 10l2.5 2.5L15.5 8", group: "System", adminOnly: true },
];

const GROUP_ORDER = ["Work", "Security", "Analytics", "System"];

const GROUP_COLORS: Record<string, string> = {
  Work: "#bd93f9",
  Security: "#ff5555",
  Analytics: "#8be9fd",
  System: "#6272a4",
};

interface AppLauncherProps {
  onNavigate: (route: string) => void;
  onClose: () => void;
  activeRoute: string;
}

export function AppLauncher({ onNavigate, onClose, activeRoute }: AppLauncherProps) {
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [hoveredTile, setHoveredTile] = useState<string | null>(null);
  const searchRef = useRef<HTMLInputElement>(null);
  const overlayRef = useRef<HTMLDivElement>(null);

  // Focus search on mount
  useEffect(() => {
    const timer = setTimeout(() => searchRef.current?.focus(), 50);
    return () => clearTimeout(timer);
  }, []);

  // Close on Escape
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // Filter tiles
  const visibleTiles = APP_TILES.filter((tile) => {
    if (tile.adminOnly && !user?.admin) return false;
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      tile.label.toLowerCase().includes(q) ||
      tile.id.toLowerCase().includes(q) ||
      tile.group.toLowerCase().includes(q)
    );
  });

  // Group tiles
  const grouped = GROUP_ORDER.map((group) => ({
    group,
    tiles: visibleTiles.filter((t) => t.group === group),
  })).filter((g) => g.tiles.length > 0);

  const handleTileClick = (id: string) => {
    onNavigate(id);
    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === overlayRef.current) onClose();
  };

  return (
    <div
      ref={overlayRef}
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9000,
        background: "rgba(13, 13, 13, 0.85)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: "appLauncherFadeIn 0.2s ease both",
      }}
    >
      <div
        style={{
          width: "min(720px, 90vw)",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          animation: "appLauncherSlideUp 0.25s ease both",
        }}
      >
        {/* Search bar */}
        <div style={{ marginBottom: 24, position: "relative" }}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6272a4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            ref={searchRef}
            type="text"
            placeholder="Search apps..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              width: "100%",
              padding: "12px 16px 12px 42px",
              background: "rgba(30, 30, 46, 0.9)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 12,
              color: "#f8f8f2",
              fontSize: 14,
              fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
              outline: "none",
              boxSizing: "border-box",
              transition: "border-color 0.15s ease, box-shadow 0.15s ease",
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = "rgba(189,147,249,0.5)";
              e.currentTarget.style.boxShadow = "0 0 0 2px rgba(189,147,249,0.15)";
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
              e.currentTarget.style.boxShadow = "none";
            }}
          />
          <div
            style={{
              position: "absolute",
              right: 14,
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 11,
              color: "#6272a4",
              fontFamily: "'JetBrains Mono', monospace",
              padding: "2px 6px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: 4,
              border: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            ESC
          </div>
        </div>

        {/* Grid groups */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            paddingRight: 4,
          }}
        >
          {grouped.length === 0 && (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#6272a4", fontSize: 13, fontFamily: "'JetBrains Mono', monospace" }}>
              No apps matching "{search}"
            </div>
          )}
          {grouped.map(({ group, tiles }) => (
            <div key={group} style={{ marginBottom: 28 }}>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  color: GROUP_COLORS[group] || "#6272a4",
                  marginBottom: 12,
                  paddingLeft: 4,
                  fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
                }}
              >
                {group}
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: 8,
                }}
              >
                {tiles.map((tile) => {
                  const isActive = activeRoute === tile.id;
                  const isHovered = hoveredTile === tile.id;
                  return (
                    <button
                      key={tile.id}
                      onClick={() => handleTileClick(tile.id)}
                      onMouseEnter={() => setHoveredTile(tile.id)}
                      onMouseLeave={() => setHoveredTile(null)}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 8,
                        padding: "16px 8px",
                        background: isActive
                          ? "rgba(80, 250, 123, 0.08)"
                          : isHovered
                          ? "rgba(255, 255, 255, 0.04)"
                          : "rgba(30, 30, 46, 0.5)",
                        border: isActive
                          ? "1px solid rgba(80, 250, 123, 0.25)"
                          : "1px solid rgba(255,255,255,0.06)",
                        borderRadius: 12,
                        cursor: "pointer",
                        transition: "all 0.15s ease",
                        transform: isHovered ? "translateY(-2px)" : "none",
                        boxShadow: isHovered
                          ? "0 4px 16px rgba(0,0,0,0.3)"
                          : "none",
                        color: isActive ? "#50fa7b" : isHovered ? "#f8f8f2" : "#a8b2b8",
                        fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
                      }}
                    >
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: 10,
                          background: isActive
                            ? "rgba(80, 250, 123, 0.12)"
                            : "rgba(255, 255, 255, 0.04)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.15s ease",
                        }}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          style={{ width: 18, height: 18 }}
                        >
                          <path d={tile.icon} />
                        </svg>
                      </div>
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: isActive ? 600 : 400,
                          textAlign: "center",
                          lineHeight: 1.2,
                        }}
                      >
                        {tile.label}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
